export const presetBanners = {
    1: {title: 'Automotive', path: '/images/automotive-banner.png'},
    2: {title: 'Computer Services', path: '/images/computer-services-banner.png'},
    3: {title: 'Financial', path: '/images/financial-banner.png'},
    4: {title: 'Health and Beauty', path: '/images/health-and-beauty-banner.png'},
    5: {title: 'Home Improvement', path: '/images/home-improvement-banner.png'},
    6: {title: 'Insurance', path: '/images/insurance-banner.png'},
    7: {title: 'Legal', path: '/images/legal-banner.png'},
    8: {title: 'Personal Services', path: '/images/personal-services-banner.png'},
    9: {title: 'Real Estate', path: '/images/real-estate-banner.png'}
};